function ContactButton(): JSX.Element {
  return (
    <div className="mt-8 text-center">
      <a
        className="inline-block px-6 py-3 bg-white text-blue-600 border border-blue-600 rounded-lg hover:bg-white transition-colors font-semibold"
        href="mailto:qtvhao@gmail.com"
      >
        Contact Me
      </a>
    </div>
  );
}

export default ContactButton;